import React from 'react'
import styled from 'styled-components/native'
import Button from 'APP/Converse/Button'
import I18n from 'APP/I18n'

const ButtonBar = styled.View`
  flex-direction: row;
  justify-content: space-between;
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

interface DeclineAcceptButtonBarProps {
  flow: 'signupFlow' | 'startupFlow'
  onDecline: () => void
  onAccept: () => void
  submitDisabled: boolean
}

const DeclineAcceptButtonBar: React.FC<DeclineAcceptButtonBarProps> = ({
  flow,
  onDecline,
  onAccept,
  submitDisabled,
}) => (
  <ButtonBar>
    <Button
      variant="secondary"
      widthVariant="flex"
      title={I18n.t('ConsentScreen.actions.cancel')}
      onPress={onDecline}
      analyticsName="ConsentScreen.actions.cancel"
      testID="CONSENT_SCREEN_CANCEL_ACTION_BTN"
    />
    <Button
      variant="primary"
      widthVariant="flex"
      title={I18n.t(`ConsentScreen.${flow}.actions.finish`)}
      analyticsName="Accept"
      disabled={submitDisabled}
      onPress={onAccept}
      testID="CONSENT_SCREEN_FINISH_ACTION_BTN"
    />
  </ButtonBar>
)

export default DeclineAcceptButtonBar
